<template>
  <common-page-table
    :apiName="apiName"
    :nameRole="nameRoleEntity"
    :titleTable="$t('Контрагенты')"
    :paramsGetData="paramsGetData"
    :fieldLand="fieldLang"
    :keyTable="'counterpartyId'"
    :deleteParams="deleteParams"
    :apiDeleteName="apiDeleteName"
    :alternativeConverter="convertData"
    :isDefaultConverter="false"
    :forceIsEdit="false"
    :forceIsCreate="false"
     :forceDelete="false"
  />
</template>
<script>
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageTable from "../../commonElement/CommonPageTable.vue";
import { API_METHODS, FIELD_LANG_COMPANY} from "../../../../constant";
import convertLangDataToTable from "../../../../helpers/converters/convertLangDataToTable";
export default {
  name: "CounterpartiesTablePage",
  components: { CommonPageTable },
  data() {
    return {
      fieldLang: FIELD_LANG_COMPANY,
      apiName: API_METHODS.GET_ALL_COUNTERPARTIES,
      apiDeleteName: API_METHODS.DELETE_COUNTERPARTY
    };
  },
  computed: {
    paramsGetData() {
      return { typeCompany: 'Client' };
    },
    nameRoleEntity() {
      return NAME_OBJECT.clients
    }
  },
  methods: {
    convertData(dataNow, langNow) {
      let res = convertLangDataToTable(dataNow, langNow, FIELD_LANG_COMPANY)
      return res;
    },
    deleteParams(id) {
      return { id: id };
    },
  }
};
</script>

